"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSharedConfiguration = void 0;
var _react = require("react");
var _context = require("../../context");
const useSharedConfiguration = () => {
  const context = (0, _react.useContext)(_context.sharedConfigurationContext);
  if (context) {
    return context;
  }
  throw new Error('Value for `sharedConfigurationContext` must be set.');
};
exports.useSharedConfiguration = useSharedConfiguration;